function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { useCallback, useRef } from 'react';
import { animate, scrollTo } from '@okee-uikit/react-utils';
import { useRefCallback } from '../../../callback/ref-callback';
import { useRefGetter } from '../../use';
import { getElementScroll } from '../../co-dom';
import { useContainer } from './useContainer';
export function useScrollTo(container, direction, targetPosition, duration, enable) {
  var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
  var getContainer = useContainer(container);
  var stopRef = useRef(null);
  var start = options.start,
      end = options.end,
      animateType = options.animateType;
  var startCallback = useRefCallback(start);
  var endCallback = useRefCallback(end);
  var directionGetter = useRefGetter(direction);
  var targetPositionGetter = useRefGetter(targetPosition);
  var enableGetter = useRefGetter(enable);
  var durationGetter = useRefGetter(duration);
  var animateTypeGetter = useRefGetter(animateType);
  var handleStartAnimate = useCallback(function (targetPosition) {
    var targetElem = getContainer();

    if (!enableGetter()() || targetElem == null) {
      return;
    }

    var tPosition = targetPosition || targetPositionGetter();
    tPosition = typeof tPosition === 'number' ? tPosition : tPosition();
    var scrollObj = getElementScroll(targetElem);
    var scrollMethod = directionGetter() === 'left' ? 'scrollLeft' : 'scrollTop';
    var startPos = scrollObj[scrollMethod];
    var distance = tPosition - startPos;
    startCallback();
    var durationTime = durationGetter();
    durationTime = typeof durationTime === 'number' ? durationTime : durationTime();

    var tick = function tick(percent) {
      scrollTo(targetElem, _defineProperty({}, directionGetter(), startPos + percent * distance));
    };

    var _animate = animate(animateTypeGetter() || 'easeInOut', durationTime, tick, endCallback),
        _animate2 = _slicedToArray(_animate, 2),
        start = _animate2[0],
        stop = _animate2[1];

    start();
    stopRef.current = stop;
  }, []);
  var handleStopAnimate = useCallback(function () {
    stopRef.current && stopRef.current();
  }, []);
  return {
    startScroll: handleStartAnimate,
    stopScroll: handleStopAnimate
  };
}